module.exports = __webpack_public_path__ + "img/phone-blue.85a818ef.svg";